<button type="button" (click)="decrement()" 
  [disabled]="disabled || control.disabled || control.value <= min" 
  [tabindex]="disabled || control.disabled || control.value <= min ? -1 : 0" 
  [cxFocus]="{ key: 'decrement' }" attr.aria-label="{{ 'itemCounter.removeOne' | cxTranslate }}" 
  >
  -
</button>

<input #qty type="text" knBrNumbersOnly [min]="min" [max]="max" 
  [step]="step" [readonly]="readonly" (change)="incrementToValue(qty.value)" 
  [disabled]="disabled || control.disabled" [tabindex]="readonly || disabled ? -1 : 0" 
  [formControl]="control" (keyup.enter)="updateValue()" 
  [cxFocus]="{ key: 'qty' }" attr.aria-label="{{ 'itemCounter.quantity' | cxTranslate }}" 
  [attr.aria-describedby]="ariaDescribedById" [class.disable]="(disabled || control.disabled)"
/>

<button
  type="button" (click)="increment()" [disabled]="disabled || control.disabled || control.value >= max"
  [tabindex]="disabled || control.disabled || control.value >= max ? -1 : 0"
  [cxFocus]="{ key: 'increment' }"
  attr.aria-label="{{ 'itemCounter.addOneMore' | cxTranslate }}"
>
  +
</button>
